export interface Testimonial {
  name: string
  location: string
  meta: string
  quote: string
  avatar: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'María Fernanda',
    location: 'México',
    meta: 'Ingreso extra en Navidad',
    quote:
      'La Navidad pasada comencé a hacer esferas navideñas con esta guía y terminó siendo mucho más que un hobby. Empecé regalando algunas a familiares y después me comenzaron a pedir más. Con ese ingreso extra pude comprar todos los regalos de Navidad para mis hijos. Estoy muy feliz de haber encontrado una actividad tan bonita y rentable.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/076dc22e-181c-44d8-b679-5df29da53351.jpg',
  },
  {
    name: 'Carolina',
    location: 'Argentina',
    meta: 'Decoró su propio árbol',
    quote:
      'Siempre quise decorar mi árbol con algo hecho por mí y esta guía fue perfecta. Las plantillas me ayudaron muchísimo porque no sabía dibujar, solo tuve que elegir mis diseños favoritos y seguir los pasos. Terminé creando unas esferas hermosas que ahora son la parte más especial de mi decoración navideña.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/3d035227-024d-480c-976f-9f244ede27ba.jpg',
  },
  {
    name: 'Patricia',
    location: 'Colombia',
    meta: 'Emprende desde hace 2 años',
    quote:
      'Hace 2 años empecé mi pequeño emprendimiento de esferas navideñas gracias a esta guía. En esta época del año siempre recibo pedidos para souvenirs de eventos, regalos personalizados y decoraciones especiales. Me encanta porque puedo crear diseños diferentes y trabajar desde casa con algo que disfruto.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/8eb94d54-d488-4f21-9835-e56c05a150ca.jpg',
  },
  {
    name: 'Luciana',
    location: 'Uruguay',
    meta: 'Creó junto a sus hijos',
    quote:
      'Pasé una tarde completa decorando esferas con mis hijos utilizando los stickers y diseños que trae la guía. Fue una actividad muy entretenida para compartir en familia, ellos se divirtieron muchísimo y al final terminamos con decoraciones hechas por nosotros para nuestro árbol.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/7b3f6d79-826e-4b76-89c4-b42500652d69.jpg',
  },
  {
    name: 'Ana Sofía',
    location: 'Chile',
    meta: 'Su momento tranquilo de la semana',
    quote:
      'Me encantó porque encontré una actividad para desconectarme un rato de la rutina. Pasaba mucho tiempo con el celular y quería hacer algo más creativo con mis manos. Decorar estas esferas se convirtió en mi momento tranquilo de la semana.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/a2d9e533-c289-4761-9204-bc3ff38ce95f.jpg',
  },
  {
    name: 'Elena',
    location: 'Argentina',
    meta: 'Una nueva forma de disfrutar sus tardes',
    quote:
      'Mi médico me recomendó buscar una actividad para hacer por las tardes y mantener mis manos en movimiento. Comencé con esta guía sin imaginar cuánto me iba a gustar. Estoy muy contenta porque además de crear cosas lindas, encontré un momento para mí y una nueva forma de disfrutar mis tardes.',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/d191b108-a206-48e9-b0d3-67a657fa5296.jpg',
  },
]
